import { jsx, jsxs } from "react/jsx-runtime";
import $670gB$react, { useState, Children, useEffect } from "react";
import { Box } from "../Box/Box.mjs";
import { MultiStepModalProvider, useMultiStepModalContext } from "./MultiStepModalContext.mjs";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import { useResponsiveValue } from "../useResponsiveValue/useResponsiveValue.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import { Divider } from "../Divider/Divider.mjs";
import { Hidden } from "../Hidden/Hidden.mjs";
import "../Hidden/Hidden.css.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Accordion/AccordionContext.mjs";
import "../private/defaultTextProps.mjs";
import "../../css/typography.css.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import "../Columns/ColumnsContext.mjs";
import "../Column/Column.css.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import { IconArrowLeft } from "../icons/IconArrowLeft/IconArrowLeft.mjs";
import { IconArrowRight } from "../icons/IconArrowRight/IconArrowRight.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import { Bleed } from "../Bleed/Bleed.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/BackgroundContext.mjs";
import "../Box/ColoredBox.mjs";
import { Button } from "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import { Dialog } from "../Dialog/Dialog.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../Dropdown/Dropdown.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../SearchField/SearchField.mjs";
import "../RadioBar/RadioBarContext.mjs";
import "../RadioBar/RadioBar.css.mjs";
import "../../themes/vars.css.mjs";
import "../RadioBar/RadioBar.mjs";
const RenderDialog = ({
  children,
  currentStep,
  id,
  stepProps,
  visible,
  showButtonIcons,
  goNext,
  goBack,
  handleClose,
  totalSteps,
  loading = false,
  ...restProps
}) => {
  const {
    nextAction,
    tertAction,
    title,
    headerIllustration,
    nextText,
    backText,
    tertText,
    nextButtonDisabled = false
  } = stepProps;
  const { goToStep } = useMultiStepModalContext();
  const handleNext = () => {
    if (nextAction) {
      nextAction({ goNext, goToStep });
    } else if (!nextButtonDisabled) goNext();
  };
  const hasTertiary = tertAction && tertText;
  const handleBack = () => {
    goBack();
  };
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  });
  const responsiveWidth = isMobile ? "full" : void 0;
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      title,
      actionButton: currentStep > 0 && /* @__PURE__ */ jsx(Hidden, { above: "mobile", children: /* @__PURE__ */ jsx(
        Button,
        {
          disabled: loading,
          variant: "transparent",
          tone: headerIllustration ? "neutral" : void 0,
          icon: /* @__PURE__ */ jsx(IconArrowLeft, {}),
          onClick: handleBack,
          children: backText
        }
      ) }),
      id,
      open: visible,
      onClose: handleClose,
      headerIllustration,
      ...restProps,
      children: [
        children,
        /* @__PURE__ */ jsx(Hidden, { above: "mobile", children: /* @__PURE__ */ jsx(Box, { marginTop: "medium", children: /* @__PURE__ */ jsx(Bleed, { horizontal: "gutter", children: /* @__PURE__ */ jsx(Divider, {}) }) }) }),
        /* @__PURE__ */ jsx(Box, { paddingTop: { mobile: "medium", desktop: "large" }, children: /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(
          Box,
          {
            width: "full",
            display: "flex",
            justifyContent: {
              mobile: "spaceBetween",
              desktop: currentStep === 0 ? "flexEnd" : "spaceBetween"
            },
            children: [
              currentStep > 0 && /* @__PURE__ */ jsx(Hidden, { below: "tablet", children: /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
                Button,
                {
                  disabled: loading,
                  variant: "transparent",
                  icon: showButtonIcons ? /* @__PURE__ */ jsx(IconArrowLeft, {}) : void 0,
                  onClick: handleBack,
                  children: backText
                }
              ) }) }),
              /* @__PURE__ */ jsx(Box, { width: responsiveWidth, children: /* @__PURE__ */ jsxs(
                Box,
                {
                  flexDirection: { mobile: "columnReverse", desktop: "row" },
                  width: responsiveWidth,
                  display: "flex",
                  children: [
                    hasTertiary && /* @__PURE__ */ jsx(Box, { width: responsiveWidth, marginRight: { mobile: "none", desktop: "small" }, children: /* @__PURE__ */ jsx(Button, { disabled: loading, onClick: tertAction, variant: "transparent", children: tertText }) }),
                    /* @__PURE__ */ jsx(Box, { marginBottom: { mobile: "small", desktop: "none" }, width: responsiveWidth, children: /* @__PURE__ */ jsx(
                      Button,
                      {
                        disabled: loading || nextButtonDisabled,
                        loading,
                        iconPosition: "trailing",
                        icon: showButtonIcons && currentStep < totalSteps - 1 ? /* @__PURE__ */ jsx(IconArrowRight, {}) : void 0,
                        onClick: handleNext,
                        children: nextText
                      }
                    ) })
                  ]
                }
              ) })
            ]
          }
        ) }) })
      ]
    }
  );
};
const MultiStepModal = ({
  children,
  initialStep = 0,
  id,
  title,
  visible,
  showButtonIcons = false,
  handleClose,
  ...restProps
}) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const filteredSteps = Children.toArray(children).filter((child) => {
    if ($670gB$react.isValidElement(child)) return child.props.enabled !== false;
    return false;
  });
  const step = filteredSteps == null ? void 0 : filteredSteps[currentStep];
  const goNext = () => {
    if (currentStep < filteredSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const goToStep = (stepNum) => {
    setCurrentStep(stepNum);
  };
  const totalSteps = filteredSteps.length;
  const isModalClosed = visible === false;
  useEffect(() => {
    if (isModalClosed) return setCurrentStep(initialStep);
  }, [initialStep, isModalClosed]);
  return /* @__PURE__ */ jsx(MultiStepModalProvider, { goToStep, children: /* @__PURE__ */ jsx(
    RenderDialog,
    {
      visible,
      handleClose,
      goNext,
      goBack,
      title,
      id,
      stepProps: step.props,
      showButtonIcons,
      totalSteps,
      currentStep,
      ...restProps,
      children: filteredSteps[currentStep]
    }
  ) });
};
const MultiModalStep = ({ children }) => children;
MultiStepModal.Step = MultiModalStep;
export {
  MultiStepModal
};
